import type { EventAttributes } from '@atlassian/jira-issue-analytics/src/services/update-issue-field/types.tsx';

export const getActionTaken = (
	oldValId: EventAttributes['oldValId'],
	newValId: EventAttributes['newValId'],
): EventAttributes['actionTaken'] => {
	if (oldValId !== newValId) {
		if (newValId === null) return 'remove';
		if (oldValId === null || oldValId === undefined) return 'add';
	}
	return undefined;
};
